import React, { useEffect } from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Button,
    Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import FormularioNichos from "./components/FormularioNichos";


export default function Dev() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <Header />
            <Box sx={{ background: "#fff", marginTop: 2 }}>
                {/* HERO */}
                <Box
                    sx={{
                        position: "relative",
                        overflow: "hidden",
                        py: { xs: 10, md: 18 },
                        background: `
                            radial-gradient(circle at top left, rgba(156,1,185,0.12), transparent 40%),
                            radial-gradient(circle at bottom right, rgba(30,255,134,0.10), transparent 40%),
                            #FFFFFF
                        `,
                    }}
                >
                    {/* Glow Roxo */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 450,
                            height: 450,
                            background: "#9C01B9",
                            opacity: 0.08,
                            borderRadius: "50%",
                            filter: "blur(120px)",
                            top: -150,
                            left: -150,
                        }}
                    />

                    {/* Glow Verde */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 400,
                            height: 400,
                            background: "#1EFF86",
                            opacity: 0.08,
                            borderRadius: "50%",
                            filter: "blur(120px)",
                            bottom: -150,
                            right: -100,
                        }}
                    />

                    <Container maxWidth="lg">
                        <Stack
                            spacing={4}
                            alignItems="center"
                            textAlign="center"
                            sx={{
                                position: "relative",
                                zIndex: 2,
                            }}
                        >
                            {/* Badge */}
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(156,1,185,0.08)",
                                    border: "1px solid rgba(156,1,185,0.15)",
                                    backdropFilter: "blur(10px)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: 14,
                                        fontWeight: 700,
                                        color: "#9C01B9",
                                    }}
                                >
                                    ESPECIALISTA EM DESENVOLVEDORES
                                </Typography>
                            </Box>

                            {/* Título */}
                            <Typography
                                component="h1"
                                sx={{
                                    fontWeight: 900,
                                    lineHeight: 1,
                                    letterSpacing: "-0.04em",
                                    maxWidth: 1000,
                                    fontSize: {
                                        xs: "2.8rem",
                                        sm: "4rem",
                                        md: "5.5rem",
                                    },
                                }}
                            >
                                Contabilidade para{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        background:
                                            "linear-gradient(90deg,#9C01B9 0%, #1EFF86 100%)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    Desenvolvedores
                                </Box>
                            </Typography>

                            {/* Subtítulo */}
                            <Typography
                                sx={{
                                    maxWidth: 800,
                                    color: "#5A5A5A",
                                    fontWeight: 400,
                                    lineHeight: 1.7,
                                    fontSize: {
                                        xs: "1.05rem",
                                        md: "1.35rem",
                                    },
                                }}
                            >
                                Dev que opera no CPF paga até 27,5% de IR sobre cada pagamento. Com CNPJ PJ no Simples Nacional e Fator R planejado, você começa com 6%, e ainda emite nota fiscal para qualquer empresa no Brasil ou no exterior.
                            </Typography>

                            {/* CTA */}
                            <Button
                                size="large"
                                sx={{
                                    px: 5,
                                    py: 2,
                                    borderRadius: "16px",
                                    fontWeight: 800,
                                    fontSize: "1rem",
                                    textTransform: "none",
                                    background:
                                        "linear-gradient(135deg,#9C01B9 0%, #B800D8 100%)",
                                    color: "#FFF",
                                    boxShadow:
                                        "0 20px 40px rgba(156,1,185,0.30)",
                                    transition: ".3s",
                                    "&:hover": {
                                        transform: "translateY(-3px)",
                                        boxShadow:
                                            "0 30px 60px rgba(156,1,185,0.45)",
                                    },
                                }}
                            >
                                Falar com Especialista
                            </Button>

                            {/* Trust Indicators */}
                            <Stack
                                direction={{ xs: "column", sm: "row" }}
                                spacing={3}
                                sx={{
                                    mt: 2,
                                }}
                            >
                                {[
                                    "Atendimento em todo Brasil",
                                    "100% Digital",
                                    "Especialistas no Nicho",
                                ].map((item) => (
                                    <Stack
                                        key={item}
                                        direction="row"
                                        spacing={1}
                                        alignItems="center"
                                    >
                                        <Box
                                            sx={{
                                                width: 10,
                                                height: 10,
                                                borderRadius: "50%",
                                                background: "#1EFF86",
                                                boxShadow:
                                                    "0 0 12px #1EFF86",
                                            }}
                                        />

                                        <Typography
                                            sx={{
                                                color: "#444",
                                                fontWeight: 600,
                                            }}
                                        >
                                            {item}
                                        </Typography>
                                    </Stack>
                                ))}
                            </Stack>
                        </Stack>
                    </Container>
                </Box>

                {/* DORES */}
                <Box
                    sx={{
                        py: { xs: 10, md: 14 },
                        position: "relative",
                        overflow: "hidden",
                        background: "#FAFAFA",
                    }}
                >
                    {/* Glow */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 500,
                            height: 500,
                            background: "#9C01B9",
                            opacity: 0.05,
                            borderRadius: "50%",
                            filter: "blur(140px)",
                            top: -200,
                            right: -150,
                        }}
                    />

                    <Container maxWidth="lg">
                        {/* Cabeçalho */}
                        <Stack
                            spacing={3}
                            alignItems="center"
                            textAlign="center"
                            sx={{ mb: 8 }}
                        >
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(156,1,185,0.08)",
                                    border: "1px solid rgba(156,1,185,0.15)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: 13,
                                        fontWeight: 700,
                                        color: "#9C01B9",
                                        letterSpacing: 1,
                                    }}
                                >
                                    PRINCIPAIS DESAFIOS
                                </Typography>
                            </Box>

                            <Typography
                                sx={{
                                    fontWeight: 900,
                                    lineHeight: 1.1,
                                    maxWidth: 900,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3.5rem",
                                    },
                                }}
                            >
                                Os problemas que mais afetam{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        background:
                                            "linear-gradient(90deg,#9C01B9,#C300E5)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    desenvolvedores
                                </Box>
                            </Typography>

                            <Typography
                                sx={{
                                    maxWidth: 750,
                                    color: "#666",
                                    fontSize: {
                                        xs: "1rem",
                                        md: "1.15rem",
                                    },
                                    lineHeight: 1.8,
                                }}
                            >
                                Um dev sênior que fatura R$15.000/mês no CPF pode pagar mais de R$4.125 em IR mensalmente, dinheiro que poderia estar investido, guardado ou no seu próximo upgrade de setup. Além disso, empresas que contratam PJs exigem nota fiscal: cada mês sem CNPJ é um contrato que você deixa de assinar.
                            </Typography>
                        </Stack>

                        {/* Cards */}
                        <Grid container spacing={3} sx={{ justifyContent: "center" }}>
                            {[
                                {
                                    title: "Pagando imposto de pessoa física sobre receita de PJ",
                                    description: "A empresa contratante exige RPA ou nota fiscal, e você não tem como emitir porque ainda opera no CPF.",
                                },
                                {
                                    title: "Pagando imposto em dobro por receber do exterior no CPF",
                                    description: "Você recebe em dólar de cliente americano ou europeu, mas não sabe como declarar corretamente sem pagar imposto em dobro.",
                                },
                                {
                                    title: "Contrato PJ mal estruturado",
                                    description: "Seu contrato PJ está mal estruturado: você é tratado como PJ mas toda a sua proteção tributária foi ignorada.",
                                },
                                {
                                    title: "Pagando imposto a mais por falta de planejamento do Fator R",
                                    description: "Você não sabe a diferença entre Anexo III e Anexo V do Simples, e pode estar pagando 13 pontos percentuais a mais sem saber.",
                                },
                                {
                                    title: "Falta de tempo para resolver a situação fiscal",
                                    description: "Nunca teve tempo de resolver a situação fiscal porque sempre tem um sprint, uma entrega, um deploy para fazer antes.",
                                },
                            ].map((item, index) => (
                                <Grid item xs={12} md={4} key={index}>
                                    <Card
                                        sx={{
                                            height: "100%",
                                            width: window.innerWidth < 600 ? "100%" : "300px",
                                            borderRadius: "28px",
                                            background:
                                                "rgba(255,255,255,0.8)",
                                            backdropFilter: "blur(20px)",
                                            border:
                                                "1px solid rgba(0,0,0,0.05)",
                                            boxShadow:
                                                "0 20px 60px rgba(0,0,0,0.06)",
                                            transition: ".35s",
                                            position: "relative",
                                            overflow: "hidden",

                                            "&:hover": {
                                                transform:
                                                    "translateY(-8px)",
                                                boxShadow:
                                                    "0 30px 80px rgba(156,1,185,0.12)",
                                            },

                                            "&:before": {
                                                content: '""',
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: 4,
                                                background:
                                                    "linear-gradient(90deg,#9C01B9,#1EFF86)",
                                            },
                                        }}
                                    >
                                        <CardContent
                                            sx={{
                                                p: 4,
                                            }}
                                        >
                                            {/* Número */}
                                            <Typography
                                                sx={{
                                                    fontSize: "4rem",
                                                    fontWeight: 900,
                                                    color:
                                                        "rgba(156,1,185,0.08)",
                                                    lineHeight: 1,
                                                    mb: 2,
                                                }}
                                            >
                                                0{index + 1}
                                            </Typography>

                                            {/* Ícone */}
                                            <Box
                                                sx={{
                                                    width: 64,
                                                    height: 64,
                                                    borderRadius: "18px",
                                                    background:
                                                        "rgba(156,1,185,0.08)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    mb: 3,
                                                }}
                                            >
                                                <WarningAmberIcon
                                                    sx={{
                                                        color: "#9C01B9",
                                                        fontSize: 32,
                                                    }}
                                                />
                                            </Box>

                                            <Typography
                                                sx={{
                                                    fontWeight: 800,
                                                    fontSize: "1.3rem",
                                                    mb: 2,
                                                }}
                                            >
                                                {item.title}
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color: "#666",
                                                    lineHeight: 1.8,
                                                }}
                                            >
                                                {item.description}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Container>
                </Box>

                {/* BENEFÍCIOS */}
                <Box
                    sx={{
                        py: { xs: 10, md: 14 },
                        background: "#050505",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    {/* Glow Roxo */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 500,
                            height: 500,
                            borderRadius: "50%",
                            background: "#9C01B9",
                            opacity: 0.15,
                            filter: "blur(180px)",
                            top: -250,
                            left: -250,
                        }}
                    />

                    {/* Glow Verde */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 450,
                            height: 450,
                            borderRadius: "50%",
                            background: "#1EFF86",
                            opacity: 0.08,
                            filter: "blur(180px)",
                            bottom: -250,
                            right: -250,
                        }}
                    />

                    <Container maxWidth="lg">
                        {/* Cabeçalho */}
                        <Stack
                            spacing={3}
                            alignItems="center"
                            textAlign="center"
                            sx={{ mb: 8 }}
                        >
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(255,255,255,0.05)",
                                    border: "1px solid rgba(255,255,255,0.08)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#1EFF86",
                                        fontSize: 13,
                                        fontWeight: 700,
                                        letterSpacing: 1,
                                    }}
                                >
                                    A SOLUÇÃO
                                </Typography>
                            </Box>

                            <Typography
                                sx={{
                                    color: "#FFF",
                                    fontWeight: 900,
                                    lineHeight: 1.1,
                                    maxWidth: 900,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3.5rem",
                                    },
                                }}
                            >
                                Como a{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        background: "#1EFF86",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    Contblack
                                </Box>{" "}
                                ajuda você a crescer com segurança
                            </Typography>

                            <Typography
                                sx={{
                                    color: "rgba(255,255,255,0.7)",
                                    maxWidth: 750,
                                    lineHeight: 1.8,
                                    fontSize: {
                                        xs: "1rem",
                                        md: "1.15rem",
                                    },
                                }}
                            >
                                A ContBlack é a contabilidade que fala a linguagem de dev. Entendemos a diferença entre contrato de desenvolvimento de software, prestação de serviço de TI, SaaS e licenciamento de software. Abrimos seu CNPJ com os CNAEs tecnológicos corretos, planejamos o Fator R para o Anexo III (6%) e garantimos que você esteja em total conformidade, sem precisar parar de codar para resolver burocracia.
                            </Typography>
                        </Stack>

                        {/* Benefícios */}
                        <Grid container spacing={4} sx={{ justifyContent: "center" }}>
                            {[
                                {
                                    title: "CNPJ com CNAEs corretos para dev",
                                    description: "CNPJ com CNAEs corretos para desenvolvimento de software, consultoria de TI, segurança da informação e SaaS.",
                                    result: "CNPJ estruturado para o seu modelo de negócio, sem risco de autuação fiscal",
                                },
                                {
                                    title: "Fator R planejado para pagar menos imposto",
                                    description: "Fator R planejado para Anexo III do Simples Nacional, imposto a partir de 6%, não 15,5% ou mais.",
                                    result: "Pagar o menor imposto possível, de forma legal e segura",
                                },
                                {
                                    title: "Emissão de nota fiscal para clientes nacionais e no exterior",
                                    description: "Nota fiscal para empresas nacionais e emissão de invoice para clientes no exterior.",
                                    result: "Fechar contratos maiores e receber do exterior sem pagar imposto em dobro",
                                },
                                {
                                    title: "Estrutura para receber do exterior sem pagar imposto em dobro",
                                    description: "Estrutura para receber via Wise, Payoneer, transferência SWIFT, com isenção de ISS, PIS e COFINS na exportação.",
                                    result: "Estrutura para receber do exterior sem pagar imposto em dobro",
                                },
                                {
                                    title: "Clareza financeira para múltiplas fontes de renda",
                                    description: "Declaração correta de todas as fontes: CLT + PJ, freelance nacional e internacional, renda de SaaS.",
                                    result: "Clareza financeira para múltiplas fontes de renda",
                                },
                                {
                                    title: "Suporte Especializado para Freelancers",
                                    description: "Atendimento via WhatsApp por especialista que entende o modelo de trabalho de tecnologia.",
                                    result: "Suporte especializado para freelancers",
                                },
                            ].map((item, index) => (
                                <Grid item xs={12} md={4} key={index}>
                                    <Card
                                        sx={{
                                            height: "100%",
                                            width: window.innerWidth < 600 ? "100%" : "300px",
                                            background:
                                                "rgba(255,255,255,0.04)",
                                            backdropFilter: "blur(20px)",
                                            border:
                                                "1px solid rgba(255,255,255,0.08)",
                                            borderRadius: "28px",
                                            position: "relative",
                                            overflow: "hidden",
                                            transition: ".35s",

                                            "&:hover": {
                                                transform:
                                                    "translateY(-8px)",
                                                border:
                                                    "1px solid rgba(30,255,134,0.25)",
                                                boxShadow:
                                                    "0 30px 80px rgba(30,255,134,0.08)",
                                            },

                                            "&::before": {
                                                content: '""',
                                                position: "absolute",
                                                left: 0,
                                                top: 0,
                                                width: 4,
                                                height: "100%",
                                                background:
                                                    "linear-gradient(180deg,#9C01B9,#1EFF86)",
                                            },
                                        }}
                                    >
                                        <CardContent sx={{ p: 4 }}>
                                            <Box
                                                sx={{
                                                    width: 70,
                                                    height: 70,
                                                    borderRadius: "20px",
                                                    background:
                                                        "rgba(30,255,134,0.08)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    mb: 3,
                                                }}
                                            >
                                                <CheckCircleIcon
                                                    sx={{
                                                        fontSize: 38,
                                                        color: "#1EFF86",
                                                    }}
                                                />
                                            </Box>

                                            <Typography
                                                sx={{
                                                    color: "#FFF",
                                                    fontWeight: 800,
                                                    fontSize: "1.35rem",
                                                    mb: 2,
                                                }}
                                            >
                                                {item.title}
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color:
                                                        "rgba(255,255,255,0.7)",
                                                    lineHeight: 1.8,
                                                    mb: 3,
                                                }}
                                            >
                                                {item.description}
                                            </Typography>

                                            <Box
                                                sx={{
                                                    borderTop:
                                                        "1px solid rgba(255,255,255,0.08)",
                                                    pt: 2,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: "#1EFF86",
                                                        fontWeight: 700,
                                                        fontSize: ".95rem",
                                                    }}
                                                >
                                                    ✓ {item.result}
                                                </Typography>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Container>
                </Box>

                {/* FAQ */}
                <Box
                    sx={{
                        py: { xs: 10, md: 14 },
                        background: "#FFFFFF",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    <Container maxWidth="md">
                        <Stack
                            spacing={3}
                            alignItems="center"
                            textAlign="center"
                            sx={{ mb: 7 }}
                        >
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(156,1,185,0.08)",
                                    border: "1px solid rgba(156,1,185,0.15)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#9C01B9",
                                        fontSize: 13,
                                        fontWeight: 700,
                                        letterSpacing: 1,
                                    }}
                                >
                                    DÚVIDAS FREQUENTES
                                </Typography>
                            </Box>

                            <Typography
                                sx={{
                                    fontWeight: 900,
                                    lineHeight: 1.1,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3.5rem",
                                    },
                                }}
                            >
                                Perguntas que recebemos com frequência
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#666",
                                    maxWidth: 700,
                                    lineHeight: 1.8,
                                }}
                            >
                                Separamos as principais dúvidas sobre contabilidade,
                                tributação e regularização para developers.
                            </Typography>
                        </Stack>

                        {[
                            {
                                question: "Qual CNAE devo usar para desenvolvimento de software?",
                                answer: "Os principais são 6201-5/01 (desenvolvimento de programas de computador sob encomenda), 6202-3/00 (desenvolvimento de software customizável) e 6209-1/00 (suporte técnico). A ContBlack define a combinação correta para a sua atividade específica.",
                            },
                            {
                                question: "Como funciona o Fator R para devs?",
                                answer: "O Fator R é a relação entre sua folha de pagamento e o faturamento. Com Fator R acima de 28%, você vai para o Anexo III (6%). Sem planejamento, pode cair no Anexo V (até 19,5%). A diferença é enorme, a ContBlack garante que você mantenha o Fator R correto.",
                            },
                            {
                                question: "Posso ter CNPJ e ainda trabalhar no regime CLT ao mesmo tempo?",
                                answer: "Sim. CNPJ não impede vínculo CLT, desde que não haja cláusula de exclusividade no contrato de trabalho. A ContBlack orienta sobre como declarar as duas fontes de renda corretamente no IR.",
                            }
                        ].map((item, index) => (
                            <Accordion
                                key={index}
                                disableGutters
                                elevation={0}
                                sx={{
                                    mb: 2,
                                    borderRadius: "20px !important",
                                    overflow: "hidden",
                                    border: "1px solid rgba(0,0,0,0.08)",
                                    boxShadow:
                                        "0 10px 30px rgba(0,0,0,0.04)",

                                    "&:before": {
                                        display: "none",
                                    },
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            sx={{
                                                color: "#9C01B9",
                                            }}
                                        />
                                    }
                                    sx={{
                                        minHeight: 80,
                                        px: 3,
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: 700,
                                            fontSize: {
                                                xs: "1rem",
                                                md: "1.1rem",
                                            },
                                        }}
                                    >
                                        {item.question}
                                    </Typography>
                                </AccordionSummary>

                                <AccordionDetails
                                    sx={{
                                        px: 3,
                                        pb: 3,
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#666",
                                            lineHeight: 1.8,
                                        }}
                                    >
                                        {item.answer}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}

                        {/* CTA Final */}
                        <Box
                            sx={{
                                mt: 6,
                                p: 4,
                                borderRadius: "24px",
                                background:
                                    "linear-gradient(135deg, rgba(156,1,185,0.05), rgba(30,255,134,0.05))",
                                border: "1px solid rgba(156,1,185,0.08)",
                                textAlign: "center",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 800,
                                    fontSize: {
                                        xs: "1.2rem",
                                        md: "1.5rem",
                                    },
                                    mb: 1,
                                }}
                            >
                                Ainda ficou com alguma dúvida?
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#666",
                                    mb: 3,
                                }}
                            >
                                Converse com um especialista e receba uma orientação
                                personalizada para sua situação.
                            </Typography>

                            <Button
                                sx={{
                                    background: "#9C01B9",
                                    color: "#FFF",
                                    px: 4,
                                    py: 1.5,
                                    borderRadius: "14px",
                                    fontWeight: 700,

                                    "&:hover": {
                                        background: "#83009A",
                                    },
                                }}
                            >
                                Falar com Especialista
                            </Button>
                        </Box>
                    </Container>
                </Box>

                <FormularioNichos nicho="Dev" />

                {/* FOOTER */}
                <Footer />
            </Box>
        </>
    );
}